// extracted by mini-css-extract-plugin
export var actionButton = "_iz-t";
export var buttonContainer = "_iz-0";
export var buttonContainer2 = "_iz-1";
export var buttonSection = "_iz-2";
export var details = "_iz-3";
export var dropdownItem = "_iz-5";
export var dropdownItemsContainer = "_iz-4";
export var fileInput = "_iz-r";
export var headerButton = "_iz-6";
export var icon = "_iz-7";
export var input = "_iz-8";
export var macroListItem = "_iz-9";
export var mainContent = "_iz-a";
export var microText = "_iz-b";
export var modal = "_iz-w";
export var optionsButton = "_iz-c";
export var paperclip = "_iz-s";
export var pillContent = "_iz-d";
export var preview = "_iz-e";
export var preview2 = "_iz-f";
export var quillEditor = "_iz-q";
export var selectedMacro = "_iz-g";
export var sidebar = "_iz-h";
export var sidebarHeader = "_iz-j";
export var sidebarList = "_iz-i";
export var sidebarListItem = "_iz-k";
export var sidebarSearch = "_iz-l";
export var snoozeDurationWrapper = "_iz-v";
export var statusPillContainer = "_iz-m";
export var tagsContainer = "_iz-n";
export var unselectedMacro = "_iz-o";
export var variable = "_iz-u";
export var wrapper = "_iz-p";